import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/Services/Translation/Translation.service';

@Component({
  selector: 'embryo-Sales',
  templateUrl: './Sales.component.html',
  styleUrls: ['./Sales.component.scss']
})
export class SalesComponent implements OnInit {

  constructor(public translate:TranslateService, public trans:TranslationService) { }

  ngOnInit() {
  }

}
